import axios from "axios";
import apiURI from "./Api";

export default class PhysicalStoreService {
  async createTransaction({ amount, user }) {
    const bodyJson = {
      amount: amount,
      seller_username: user,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/store/createTransaction`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async getAllPayments() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/store/getAllPayments/${localStorage.getItem("__extraconomy_username")}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async getPayment(id) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/store/getPaymentById/${id}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async confirmTransaction({
    amount,
    authentication,
    paymentid,
    amountWalletExtraCredit,
    buyer_username,
  }) {
    const bodyJson = {
      amountWallet: amount,
      amountWalletExtraCredit: amountWalletExtraCredit,
      authentication: authentication,
      buyer_username: buyer_username,
      paymentid: paymentid,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/store/confirmTransaction`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }
}
